import { jsxs as i, jsx as o } from "react/jsx-runtime";
import l from "../../../svg-icon/svg-icon.component.js";
function e(t) {
  return /* @__PURE__ */ i(
    l,
    {
      width: "32",
      height: "31",
      viewBox: "0 0 32 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            d: "M8.64437 18.6228C7.99708 16.8311 7.66549 13.9567 9.1616 11.2201C10.5237 8.72803 12.9798 7.172 16.0018 7.172C19.3763 7.172 21.6666 9.06974 22.842 11.2201C24.2706 13.8339 24.0423 16.732 23.3593 18.6228H31.7065C31.9259 17.4957 32.7986 12.4888 29.8848 7.63455C27.1328 3.04966 22.1402 0 16.0008 0C9.519 0 4.67724 3.36463 2.11687 7.63455C-0.783026 12.47 0.0618283 17.4234 0.29513 18.6228H8.64337H8.64437Z",
            fill: "#FF5D47"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M2.39477 23.8278C4.86976 27.7015 9.46234 30.9998 16.0008 30.9998C21.7866 30.9998 26.7495 28.2978 29.6067 23.8278H2.39378H2.39477Z",
            fill: "#FF5D47"
          }
        )
      ]
    }
  );
}
export {
  e as DefaultSymbolPositiveLogo
};
//# sourceMappingURL=positive.js.map
